import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import AddChecker from './AddChecker';
import { useDispatch } from 'react-redux';
import { apiAction } from '../../store/generalSlice';
import { Link } from 'react-router-dom';

const ManageCheckers = ({ subCondition, condition }) => {
  const dispatch = useDispatch();
  const handleDeleteChecker = (checkerId) => {
    if (window.confirm('Are you sure you want to delete this checker?')) {
      const updatedSubConditions = condition.subConditions.map((sc) => {
        if (sc._id === subCondition._id) {
          return {
            ...subCondition,
            checkers: Array.isArray(subCondition.checkers)
              ? subCondition.checkers.filter((flt) => flt._id !== checkerId)
              : [],
          };
        }
        return sc;
      });
      dispatch(
        apiAction({
          reduxField: 'condition',
          route: 'conditions/updateSubConditions',
          conditionId: condition._id,
          subConditions: updatedSubConditions,
        })
      );
    }
  };

  return (
    <div className='mb-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom'>
          <h1>Manage Checkers ({subCondition.checkers?.length || '0'})</h1>
        </div>
      </div>

      {subCondition.checkers?.map((ckr) => (
        <div className='row d-flex justify-content-center pt-lg-0 p-4' key={ckr._id}>
          <div className='col-md-2 border p-3'>
            <h6>{ckr.name}</h6>
          </div>
          <div className='col-md-6 border p-3'>
            <Link className='btn btn-outline-dark' to={`/editChecker/${condition._id}/${subCondition._id}/${ckr._id}`}>
              Edit Checker
            </Link>
            <button className='btn btn-outline-danger ml-2' onClick={() => handleDeleteChecker(ckr._id)}>
              Delete Checker
            </button>
          </div>
        </div>
      ))}
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <AddChecker subCondition={subCondition} condition={condition} />
      </div>
    </div>
  );
};

export default ManageCheckers;
